import { defineStore } from 'pinia';

export const useNotificationsStore = defineStore('unread-notification-count', {
  state: () => ({
    unreadNotificationsCount: 0,
  }),

  actions: {
    setUnreadNotificationCount(count: number) {
      this.unreadNotificationsCount = count;
    },
  },
});
